var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Colors, Shadows } from '@doordash/design-language';
import styled, { css } from 'styled-components';
export var HEADER_HEIGHT = 76;
// Header Container
export var HeaderRoot = styled.header(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: ", ";\n  z-index: 2;\n  height: ", "px;\n  width: 100%;\n\n  ", "\n"], ["\n  background: ", ";\n  z-index: 2;\n  height: ", "px;\n  width: 100%;\n\n  ",
    "\n"])), Colors.SystemWhite, HEADER_HEIGHT, function (props) {
    if (props.isFullPageHeader) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: sticky;\n        top: 0;\n        box-shadow: ", ";\n      "], ["\n        position: sticky;\n        top: 0;\n        box-shadow: ", ";\n      "])), Shadows.Small);
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
});
var templateObject_1, templateObject_2, templateObject_3;
